// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"5c2d12ce","420":"959e3f2a","709":"bccb68b6"}[chunkId] + ".chunk.css";
};